export default __webpack_public_path__ + "static/media/pencemaranTanah.b2e61eb8.jpg";